import { DialogTitle, DialogContent } from '@mui/material';
import Grid from '@mui/material/Grid2';
import EditGeneralInfo from './EditEventGeneralInfo';

export default function GeneralInfoStep() {
    return (
        <>
            <DialogTitle>General Info</DialogTitle>
            <DialogContent>
                <Grid container spacing={4} padding={4} paddingTop={2} alignItems={'flex-end'}>
                    <EditGeneralInfo />
                </Grid>
            </DialogContent>
        </>
    );
}
